import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const validateBranch = async (branchData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/business/validate", branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllBranches = async (businessId: string): Promise<any> => {
  try {
    const userId = getUserId();
    if (!userId) {
      throw new Error("User not logged in");
    }
    if (!businessId) {
      throw new Error("Business ID is required");
    }
    const response = await apiClient.get(`/units/all`, {
  params: { businessId },
});
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllBusinessTypes = async (): Promise<any[]> => {
  try {
    const response = await apiClient.get("/units/types");
    const raw = response.data as unknown;

    // Helper to return an array when the input is already an array
    const asArray = (value: unknown): any[] | null =>
      Array.isArray(value) ? (value as any[]) : null;

    const direct = asArray(raw);
    if (direct) return direct;

    if (raw && typeof raw === "object") {
      const record = raw as Record<string, unknown>;

      const keyed =
        asArray(record["businessTypes"]) ||
        asArray(record["types"]) ||
        asArray(record["data"]);
      if (keyed) return keyed;

      const firstArray = Object.values(record).find(
        (value): value is any[] => Array.isArray(value)
      );
      if (firstArray) {
        return firstArray;
      }
    }

    return [];
  } catch (error) {
    throw error;
  }
};

export const createBranch = async (
  branchData: PromoData | FormData
): Promise<any> => {
  try {
    const userId = getUserId();

    if (branchData instanceof FormData) {
      if (!branchData.has("user_id") && userId) {
        branchData.append("user_id", userId);
      }
      const response = await apiClient.post("/units/create", branchData);
      return response.data;
    } else {
      const payload = { ...(branchData || {}) };
      if (!payload.user_id && userId) {
        payload.user_id = userId;
      }
      const response = await apiClient.post("/units/create", payload);
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateBranch = async (
  id: string,
  branchData: PromoData,
  options?: { suppressToast?: boolean }
): Promise<any> => {
  try {
    const response = await apiClient.patch(`/units/update/${id}`, branchData, {
      suppressToast: options?.suppressToast === true,
    } as any);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getByIdBranch = async (
  id: string,
): Promise<any> => {
  try {
    const response = await apiClient.get(`/units/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteBranch = async (
  id: string,
  data: { password: string },
  options?: { suppressToast?: boolean }
): Promise<any> => {
  try {
    const response = await apiClient.delete(`/units/delete/${id}`, {
      data,
      suppressToast: options?.suppressToast === true,
    } as any);
    return response.data;
  } catch (error) {
    throw error;
  }
};
